import React, { useState } from 'react'
import './AlterationItem.css'

function AlterationItem({service, handleChange}) {
    const [showCustomInput, setShowCustomInput] = useState(false);

    const inputHandler = (event) => {
        if(event.target.value === "0") {
            setShowCustomInput(true);
            handleChange(event);
        } else {
            setShowCustomInput(false);
            handleChange(event);
        }

        
    }
    return (
        <div className="tc">    
            <fieldset className="alt-fieldset">
                <legend className="fw6"><h3>{(service.name).replaceAll('_', ' ')}</h3></legend>

                <input className="checkbox-budget" 
                       type="radio" 
                       name={service.name}
                       id={service.price[0] + service.name}
                       value={service.price[0]}
                       onChange={inputHandler}
                />
                <label className="for-checkbox-budget" htmlFor={service.price[0] + service.name}>
                    <span className="checkbox-budget-price" data-hover={"$"+service.price[0]}>{"$"+service.price[0]}</span>
                </label>

                <input className="checkbox-budget" 
                       type="radio" 
                       name={service.name}
                       id={service.price[1] + service.name}
                       value={service.price[1]}
                       onChange={inputHandler}
                />
                <label className="for-checkbox-budget" htmlFor={service.price[1]+ service.name}>
                    <span className="checkbox-budget-price" data-hover={"$"+service.price[1]}>{"$"+service.price[1]}</span>
                </label>

                <input className="checkbox-budget" 
                       type="radio" 
                       name={service.name}
                       id={service.price[2]+ service.name}
                       value={service.price[2]}
                       onChange={inputHandler}
                />
                <label className="for-checkbox-budget" htmlFor={service.price[2]+ service.name}>
                    <span className="checkbox-budget-price" data-hover={"$"+service.price[2]}>{"$"+service.price[2]}</span>
                </label>

                { service.price[3] &&
                <input className="checkbox-budget" 
                       type="radio" 
                       name={service.name}
                       id={service.price[3]+ service.name}
                       value={service.price[3]}
                       onChange={inputHandler}
                />}
                { service.price[3] &&
                <label className="for-checkbox-budget" htmlFor={service.price[3]+ service.name}>
                    <span className="checkbox-budget-price" data-hover={"$"+service.price[3]}>{"$"+service.price[3]}</span>
                </label>}


                <input className="checkbox-budget" 
                       type="radio" 
                       name={service.name}
                       id={service.name}
                       value="0"
                       onChange={inputHandler}
                />
                <label className="for-checkbox-budget" htmlFor={service.name}>
                    <span className="checkbox-budget-price" data-hover="">
                        {showCustomInput ? 
                            <input type="number" 
                                    style={{width:"80px", backgroundColor:"#C0C0C0"}}
                                    name={service.name}
                                    id={service.name}
                                    value={service.price[3]}
                                    onChange={handleChange}
                                    defaultValue="0"
                            /> : "more"}</span>
                </label> 
    
                {/* <input className="checkbox-budget"/>     */}
        
            </fieldset>     
        </div>
    )
}

export default AlterationItem